/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Card, Typography,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import companyServices from '../../../../redux/services/companyServices';
import useSemester from '../Semesters/useSemester';
import { toastError } from '../../../../redux/actions/alertActions';
import Ponderation from './components/Ponderation';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    padding: '30px 20px 30px 20px',
  },
}));

const PonderationData = ({
  company,
}) => {
  const [ponderationData, setPonderationData] = useState([]);
  const [type, setType] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { updateSemester } = useSemester(company._id, ponderationData, setPonderationData, type);
  const classes = useStyles();

  useEffect(() => {
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        setPonderationData(res.semesters);
        setType(res.adminData.type);
      });
  }, []);

  return (
    <>
      <Card className={classes.root}>
        <MaterialTable
          title="Pondération"
          data={ponderationData}
          columns={[
            {
              title: 'Semestre',
              field: 'semester',
              editable: 'never',
            },
            {
              title: 'Pourcentage e-learning',
              field: 'ponderation.elearning',
              render: (rowData) => (
                <Typography>
                  {rowData.ponderation?.elearning || '0'}
                  %
                </Typography>
              ),
              editComponent: (props) => {
                if (!props.value) {
                  props.onChange(50);
                }
                return (
                  <input
                    type="number"
                    value={props.value}
                    min={0}
                    max={100}
                    onChange={(e) => {
                      if (parseInt(e.target.value, 10) >= 0 && parseInt(e.target.value, 10) <= 100) {
                        props.onChange(e.target.value);
                        if (props.rowData.ponderation) {
                          props.rowData.ponderation.exams = 100 - parseInt(e.target.value, 10);
                        } else {
                          props.rowData.ponderation = {
                            exams: 100 - parseInt(e.target.value, 10),
                          };
                        }
                      } else {
                        toastError('Attention, la somme des pourcentages ne doit ni dépasser 100%, ni descendre sous 0%');
                      }
                    }}
                  />
                );
              },
            },
            {
              title: 'Pourcentage examens',
              field: 'ponderation.exams',
              render: (rowData) => (
                <Typography>
                  {rowData.ponderation?.exams || '0'}
                  %
                </Typography>
              ),
              editComponent: (props) => {
                if (!props.value) {
                  props.onChange(50);
                }
                return (
                  <input
                    type="number"
                    value={props.value}
                    min={0}
                    max={100}
                    onChange={(e) => {
                      if (parseInt(e.target.value, 10) >= 0 && parseInt(e.target.value, 10) <= 100) {
                        props.onChange(e.target.value);
                        if (props.rowData.ponderation) {
                          props.rowData.ponderation.elearning = 100 - parseInt(e.target.value, 10);
                        } else {
                          props.rowData.ponderation = {
                            elearning: 100 - parseInt(e.target.value, 10),
                          };
                        }
                      } else {
                        toastError('Attention, la somme des pourcentages ne doit ni dépasser 100%, ni descendre sous 0%');
                      }
                    }}
                  />
                );
              },
            },
          ]}
          editable={{
            onRowUpdate: (newData, oldData) => new Promise((resolve) => {
              const dataUpdate = [...ponderationData];
              const index = oldData.tableData.id;
              dataUpdate[index] = newData;
              updateSemester(newData, 'updatePonderation');
              setPonderationData([...dataUpdate]);
              setTimeout(() => {
                setLoaded(!loaded);
                resolve();
              }, 1000);
            }),
            onRowDelete: (oldData) => new Promise((resolve, reject) => {
              const dataUpdate = [...ponderationData];
              const index = oldData.tableData.id;
              dataUpdate[index] = { ...oldData, ponderation: null };
              updateSemester({ ...oldData, ponderation: null }, 'updatePonderation');
              setPonderationData([...dataUpdate]);
              setTimeout(() => {
                setLoaded(!loaded);
                resolve();
              }, 1000);
              resolve();
            }),
          }}
          localization={{
            body: {
              editRow: {
                deleteText: 'Voulez-vous réinitialiser les pourcentages ?',
                cancelTooltip: 'Annuler',
                saveTooltip: 'Valider',
              },
              editTooltip: 'Modifier',
              deleteTooltip: 'Supprimer',
            },
            toolbar: {
              searchTooltip: 'Rechercher',
              searchPlaceholder: 'Rechercher',
            },
            pagination: {
              labelDisplayedRows: '{from}-{to} de {count}',
              labelRowsSelect: 'lignes',
              nextTooltip: 'Page suivante',
              previousTooltip: 'Page précédente',
              firstTooltip: 'Première page',
              lastTooltip: 'Dernière page',
            },
          }}
          options={{
            pageSize: 8,
          }}
        />
      </Card>
      <Card>
        <Ponderation loaded={loaded} />
      </Card>
    </>
  );
};

PonderationData.propTypes = {
  company: PropTypes.object.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedPonderationData = connect(mapState, null)(PonderationData);

export default withRouter(connectedPonderationData);
